import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { apiV1 } from "../Auth/Interceptor";


const initialStateValue = {
    coupons: {
        coupons: [],
        loading: 'idle',
        error: null,
    },
    coupon: {
        coupon: {},
        loading: 'idle',
        error: null,
    },
    couponKebab: {
        kebabOpen: false,
        couponId: null,
    },
    modal: {
        activeModal: '',
        displayModal: false,
    },
    listModal: {
        activeListModal: '',
        displayListModal: false,
    },
    selectedKebabItem: {},
}

const fetchCoupons = createAsyncThunk('coupons/fetchCoupons', async () => {
    try {
        const response = await apiV1.get(`coupon/seller`);
        return response.data.data;
    }
    catch(error) {
        throw error;
    }
});

const fetchCouponDetails = createAsyncThunk('coupons/fetchCouponDetails', async (couponId) => {
    try {
        const response = await apiV1.get(`coupon/seller/${couponId}`);
        return response.data.data;
    }
    catch(error) {
        throw error;
    }
});

const couponsSlice = createSlice({
    name: 'coupons',
    initialState: initialStateValue,
    reducers: {
        openCouponKebabMenu: (state, action) => {
            state.couponKebab.kebabOpen = true;
            state.couponKebab.couponId = action.payload;
        },
        closeCouponKebabMenu: (state, _) => {
            state.couponKebab = initialStateValue.couponKebab;
        },
        setModal: (state, action) => {
            state.modal.activeModal = action.payload;
            state.modal.displayModal = true;
        },
        closeModal: (state, _) => {
            state.modal.activeModal = '';
            state.modal.displayModal = false;
        },
        setListModal: (state, action) => {
            state.listModal.activeListModal = action.payload;
            state.listModal.displayListModal = true;
        },
        closeListModal: (state, _) => {
            state.listModal.activeListModal = '';
            state.listModal.displayListModal = false;
        },
        setSelectedKebabItem: (state, action) => {
            state.selectedKebabItem = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
        .addCase(fetchCoupons.pending, (state) => {
            state.coupons.loading = 'loading';
        })
        .addCase(fetchCoupons.fulfilled, (state, action) => {
            state.coupons.loading = 'succeeded';
            state.coupons.coupons = action.payload;
        })
        .addCase(fetchCoupons.rejected, (state, action) => {
            state.coupons.loading = 'failed';
            state.coupons.error = action.error.message;
        })
        .addCase(fetchCouponDetails.pending, (state) => {
            state.coupon.loading = 'loading';
        })
        .addCase(fetchCouponDetails.fulfilled, (state, action) => {
            state.coupon.loading = 'succeeded';
            state.coupon.coupon = action.payload;
            state.coupon.error = null;
        })
        .addCase(fetchCouponDetails.rejected, (state, action) => {
            state.coupon.loading = 'failed';
            state.coupon.error = action.error.message;
        });
    },
});

export const {
    openCouponKebabMenu,
    closeCouponKebabMenu,
    setModal,
    closeModal,
    setListModal,
    closeListModal,
    setSelectedKebabItem,
} = couponsSlice.actions;

export {
    fetchCoupons,
    fetchCouponDetails,
}

export default couponsSlice.reducer;
